import ModeloTareaService from 'src/modules/modeloTarea/modeloTareaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'MODELOTAREA_VIEW';

const modeloTareaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: modeloTareaViewActions.FIND_STARTED,
      });

      const record = await ModeloTareaService.find(id);

      dispatch({
        type: modeloTareaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: modeloTareaViewActions.FIND_ERROR,
      });

      getHistory().push('/modelo-tarea');
    }
  },
};

export default modeloTareaViewActions;
